import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useMediaQuery } from '../../../hooks/useMediaQuery'
import Image from '../../1_Atoms/Image/Image'
import Select from '../../1_Atoms/Forms/Select/Select'
import { languageController } from '../../../controllers/language/languageController'
import Link from '../../1_Atoms/Link/Link'
import generalController from '../../../controllers/generalController'
import { getBaseUrl } from '../../../utils/helpers'
import ReactHtmlParser from 'react-html-parser';

function TrimSelector({
  index,
  defaultTrim,
  trim,
  trimOptions,
  trimPrice,
  modelYearData,
  yearData,
  modelName,
  updateTrimsOrder,
}) {
  const [activeTrim, setActiveTrim] = useState(defaultTrim)
  const isMobile = ['xs', 'sm'].includes(useMediaQuery());

  const displayType = !isMobile && index == 0 ? 'flex' : 'inherit';

  const handleSelectorChange = (e) => {
    const { value } = e.target;
    window.location.href = window.location.origin + window.location.pathname +'?trim=' + value;
  }
  // Generate an image path for jelly.
  const generateImageSrc = (modelYearData) => {
    const { jelly_path, jelly } = modelYearData;
    const imagePath = getBaseUrl() + process.env.REACT_APP_BASIC_CONTENT_PATH;
    return imagePath + jelly_path + jelly;
  }

  const generateBnPLink = (trimCode) => {
  	const lang = generalController.detectLanguage();
    const basePath = lang === 'en' ? '/shopping/build-and-price/#/' : '/magasiner/construction-et-prix/#/';
    const trimParams = `${yearData.url_slug}/${modelName}/${trimCode}`;

    if (basePath) {
      return '/' + lang + basePath + trimParams;
    }
    return ''
  }

  const getTrimWithLegalSup = () => {
    let sup = '';

    if (modelName === 'CX-50-HEV' && trim == 'GS-L' && yearData.url_slug === '2025') {
      sup = '<sup>†</sup>';
    }

    
    if (modelName === 'MX-5-SoftTop' && trim == '35th Anniversary Edition' && yearData.url_slug === '2025') {
      trim = trim.replace('th', '<sup>th</sup>');
      sup = '<sup>†3</sup>';
    }

    if (modelName === 'MX-5-SoftTop' && trim == '35e anniversaire' && yearData.url_slug === '2025') {
      trim = trim.replace('35e', '35<sup>e</sup>');
      sup = '<sup>†3</sup>';
    }

    return ReactHtmlParser(`${trim}${sup}`);
  }
  
  const convertSupToUnicode = (htmlString) =>{
    // Map for superscript replacements
    const superscriptMap = {
        '0': '⁰',
        '1': '¹',
        '2': '²',
        '3': '³',
        '4': '⁴',
        '5': '⁵',
        '6': '⁶',
        '7': '⁷',
        '8': '⁸',
        '9': '⁹',
        'a': 'ᵃ',
        'b': 'ᵇ',
        'c': 'ᶜ',
        'd': 'ᵈ',
        'e': 'ᵉ',
        'f': 'ᶠ',
        'g': 'ᵍ',
        'h': 'ʰ',
        'i': 'ⁱ',
        'j': 'ʲ',
        'k': 'ᵏ',
        'l': 'ˡ',
        'm': 'ᵐ',
        'n': 'ⁿ',
        'o': 'ᵒ',
        'p': 'ᵖ',
        'r': 'ʳ',
        's': 'ˢ',
        't': 'ᵗ',
        'u': 'ᵘ',
        'v': 'ᵛ',
        'w': 'ʷ',
        'x': 'ˣ',
        'y': 'ʸ',
        'z': 'ᶻ',
        '+': '⁺',
        '-': '⁻',
        '=': '⁼',
        '(': '⁽',
        ')': '⁾',
    };

    // Replace <sup> tags and convert their contents to Unicode
    return htmlString.replace(/<sup>(.*?)<\/sup>/g, (_, content) => {
        // Convert each character inside <sup> to its Unicode equivalent
        return [...content].map(char => superscriptMap[char] || char).join('');
    });
}

  
  return (
    <td className={index == 0 ? 'mz-table-corner mz-table-550 mz-table-tablet-350 mz-table-mobile-150': ' text--center mz-table-250 mz-table-tablet-150 mz-table-mobile-150' }>
      <div style={{display: displayType, alignItems:'center'}}>
        <Image
          className="mz-trim-selector__image"
          style={{flex:'0 0 60%'}}
          src={generateImageSrc(modelYearData)}
          isLazy={false}
        />
        <p style={{flex:'0 0 40%'}}>
          <strong>{getTrimWithLegalSup()}</strong><br/>{languageController.getCopy('specCompare', 'pricePrefix')}{trimPrice}<br/>
          <a
            href={generateBnPLink(activeTrim)}
            className="mz-link mz-trim-selector__cta"
          >{languageController.getCopy('specCompare', 'trimColumnCTALabel')}</a>
          {index == 0 &&
          <div className="mz-form-item mz-form-item--select ">
            <select className="mz-form-item__select" onChange={handleSelectorChange}>
              <option selected="" value="" disabled="">{languageController.getCopy('specCompare', 'changeTrim')}</option>
              {
                (
                  Object.keys(trimOptions).map(index => {
                    if(trim != trimOptions[index].slug){
                      return (<option value={trimOptions[index].trim}>{convertSupToUnicode(trimOptions[index].name)}</option>)
                    }
                  })
                )
              }
            </select>
            <div className="mz-form-item__arrow-down">
              <div className="mz-svg-wrapper " style={{fontSize: '0.75rem'}}>
                <i className="mz-svg mz-svg--grey undefined mz-svg-chevron_small_down"></i>
              </div>
            </div>

          </div>
          }
        </p>
      </div>
    </td>
  )
}

TrimSelector.propTypes = {
  index: PropTypes.number.isRequired,
  defaultTrim: PropTypes.string.isRequired,
  trimOptions: PropTypes.array.isRequired,
  trimPrice: PropTypes.string.isRequired,
  modelYearData: PropTypes.object.isRequired,
  yearData: PropTypes.object.isRequired,
  modelName: PropTypes.string.isRequired,
  updateTrimsOrder: PropTypes.func.isRequired,
}

export default TrimSelector